import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import leftImg from "../assets/login_left.png";
import lockIcon from "../assets/lock.png";
import backIcon from "../assets/back-arrow.png";
import EmailInput from "../components/login_forgot_email";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showForgot, setShowForgot] = useState(false);
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    console.log("Logging in with:", { email, password });
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    console.log("Recover password for:", email);
  };

  return (
    <div className="main-backgroundlogin">
      <div className="login-layout min-h-screen d-flex justify-content-between align-items-center p-4">
        <div className="w-50">
          <img src={leftImg} alt="" className="w-100" />
        </div>
        <div className="rounded-md p-6 relative" style={{ width: "40%" }}>
          <div className="mb-4 text-start">
            <img src={logo} alt="Logo" className="w-6 h-6" />
          </div>

          {showForgot && (
            <div className="text-start mt-3" style={{ marginBottom: "14px" }}>
              <a
                href="#"
                className="text-sm text-decoration-none"
                onClick={() => setShowForgot(false)}
                style={{
                  color: "#5D5D5D",
                  fontWeight: "500",
                  fontSize: "14px",
                }}
              >
                <img src={backIcon} style={{ marginBottom: "2px" }} alt="" />{" "}
                Back to login
              </a>
            </div>
          )}

          <h2
            className="text-start"
            style={{ color: "#298097", fontWeight: "700" }}
          >
            {showForgot ? "Forgot your password" : "Let the Journey Begin!"}
          </h2>

          <p
            className="text-start"
            style={{ color: "#5D5D5D", marginBottom: "20px" }}
          >
            {showForgot
              ? "Enter your account email and we will send you a password reset link if an account exists."
              : "Unlock a world of possibilities with the Employee Portal! Please log in to your account."}
          </p>

          <form onSubmit={showForgot ? handleForgotPassword : handleLogin}>
            <EmailInput email={email} setEmail={setEmail} />

            {!showForgot && (
              <>
                <label className="d-block text-start">Password</label>
                <div className="position-relative mb-2">
                  <input
                    type="password"
                    required
                    placeholder="**********"
                    className="input-base"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <div className="input-start-icon-image">
                    <img src={lockIcon} alt="" />
                  </div>
                </div>

                <div className="text-right mb-6">
                  <a
                    href="#"
                    className="text-sm text-decoration-none text-end d-block"
                    style={{ color: "#005AE2", fontWeight: "500" }}
                    onClick={() => setShowForgot(true)}
                  >
                    Forgot Password?
                  </a>
                </div>
              </>
            )}

            <button
              type="submit"
              className="dark-orange-button"
              style={{ width: "100%", marginTop: "20px" }}
            >
              {showForgot ? "Send Recovery Email" : "Login"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
